import React, { useEffect, useReducer } from 'react';
import ListaItemsGeo from './geografia/ListaItemsGeo.js';
import CuadroDatosGeo from './geografia/CuadroDatosGeo.js';
import InsertarDatosGeo from './geografia/InsertarDatosGeo.js';
import TotalesItemGeo from './geografia/TotalesItemGeo.js';
import { TituloPagina } from '../funciones/Funciones.js';
import CuadroColapsable from '../UI/CuadroColapsable.js';
import * as TipoItemGeo from '../constantes/TipoItemGeo.js';
import * as UI from '../constantes/UI.js';
import * as DTOs from '../DTOs/ItemsGeoDTOs.js';
import styles from './geografia/Geografia.module.css';

const GeografiaVacia = {
  pais: null,
  provincia: null,
  localidad: null,
  insertar: null,
  actualizarPaises: false,
  actualizarProvincias: false,
  actualizarLocalidades: false,
  // Para controlar colapsables en tablet/mobile
  expandidoPaises: true,
  expandidoProvincias: false,
  expandidoLocalidades: false,
};

const reducerGeo = (state, action) => {
  switch (action.type) {
    case TipoItemGeo.PAIS: {
      return {
        pais: action.value,
        provincia: null,
        localidad: null,
        insertar: null,
        actualizarPaises: false,
        actualizarProvincias: false,
        actualizarLocalidades: false,
        expandidoPaises: false, // Colapsar Paises
        expandidoProvincias: true, // Expandir Provincias
        expandidoLocalidades: false,
      };
    }
    case TipoItemGeo.PROVINCIA: {
      return {
        ...state,
        provincia: action.value,
        localidad: null,
        insertar: null,
        actualizarProvincias: false,
        actualizarLocalidades: false,
        expandidoProvincias: false, // Colapsar Provincias
        expandidoLocalidades: true, // Expandir Localidades
      };
    }
    case TipoItemGeo.LOCALIDAD: {
      return {
        ...state,
        localidad: action.value,
        insertar: null,
        actualizarLocalidades: false,
        expandidoLocalidades: false,
      };
    }
    case 'insertar': {
      return { ...state, insertar: action.value };
    }
    case 'insertado': {
      let actualizar;
      switch (action.value) {
        case TipoItemGeo.PAIS: {
          actualizar = !state.actualizarPaises;
          return { ...state, actualizarPaises: actualizar, insertar: null };
        }
        case TipoItemGeo.PROVINCIA: {
          actualizar = !state.actualizarProvincias;
          return { ...state, actualizarProvincias: actualizar, insertar: null };
        }
        case TipoItemGeo.LOCALIDAD: {
          actualizar = !state.actualizarLocalidades;
          return { ...state, actualizarLocalidades: actualizar, insertar: null };
        }
        default: {
          return state;
        }
      }
    }
    case 'expandidoPaises': {
      return { ...state, expandidoPaises: action.value };
    }
    case 'expandidoProvincias': {
      return { ...state, expandidoProvincias: action.value };
    }
    case 'expandidoLocalidades': {
      return { ...state, expandidoLocalidades: action.value };
    }
    default: {
      return GeografiaVacia;
    }
  }
};

const AdminGeografia = () => {
  const [geografia, setGeografia] = useReducer(reducerGeo, GeografiaVacia);

  useEffect(() => {
    document.title = TituloPagina(AdminGeografia.name);
  }, []);

  const onItemElegido = (tipoItem, itemElegido) => {
    if (geografia.insertar) {
      const result = window.confirm('¿Desea cancelar el alta?');
      if (!result) {
        return false;
      }
    }
    setGeografia({ type: tipoItem, value: itemElegido });
  };

  const onInsertarItem = (tipoItem) => {
    setGeografia({ type: 'insertar', value: tipoItem });
  };

  const onDatosActualizados = (tipoItem, itemActualizado) => {
    setGeografia({ type: tipoItem, value: itemActualizado });
  };

  const onCancelarInsert = () => {
    setGeografia({ type: 'insertar', value: '' });
  };

  const onDatosInsertados = (tipoItem, nuevoItem) => {
    setGeografia({ type: 'insertado', value: tipoItem });
  };

  const onExpandPaisesChange = (expandido) => {
    setGeografia({ type: 'expandidoPaises', value: expandido });
  };

  const onExpandProvinciasChange = (expandido) => {
    setGeografia({ type: 'expandidoProvincias', value: expandido });
  };

  const onExpandLocalidadesChange = (expandido) => {
    setGeografia({ type: 'expandidoLocalidades', value: expandido });
  };

  let cuadroDatos = null;
  let cuadroTotales = null;
  let item = null;
  let tipoItem = '';
  if (geografia.insertar) {
    tipoItem = geografia.insertar;
    switch (tipoItem) {
      case TipoItemGeo.PAIS: {
        item = DTOs.PaisVacio();
        break;
      }
      case TipoItemGeo.PROVINCIA: {
        item = DTOs.ProvinciaVacia(geografia.pais.id);
        break;
      }
      case TipoItemGeo.LOCALIDAD: {
        item = DTOs.LocalidadVacia(geografia.pais.id, geografia.provincia.id);
        break;
      }
      default:
    }
    cuadroDatos = (
      <InsertarDatosGeo
        geografia={geografia}
        tipo={tipoItem}
        item={item}
        onDatosInsertados={onDatosInsertados}
        onCancelarInsert={onCancelarInsert}
      />
    );
    cuadroTotales = '';
  } else {
    if (geografia.localidad !== null) {
      tipoItem = TipoItemGeo.LOCALIDAD;
      item = geografia.localidad;
    } else if (geografia.provincia !== null) {
      tipoItem = TipoItemGeo.PROVINCIA;
      item = geografia.provincia;
    } else if (geografia.pais !== null) {
      tipoItem = TipoItemGeo.PAIS;
      item = geografia.pais;
    }
    if (item) {
      cuadroDatos = (
        <CuadroDatosGeo tipo={tipoItem} id={item.id} onDatosActualizados={onDatosActualizados} />
      );
      cuadroTotales = <TotalesItemGeo geografia={geografia} tipo={tipoItem} item={item} />;
    }
  }

  // Componente para Paises (siempre expandido en desktop, colapsable en mobile)
  const ListaPaisesDesktop = (
    <ListaItemsGeo
      tipo={TipoItemGeo.PAIS}
      geografia={geografia}
      itemActual={geografia.pais}
      recargar={geografia.actualizarPaises}
      onItemElegido={onItemElegido}
      onInsertarItem={onInsertarItem}
    />
  );

  const ListaPaisesColapsable = (
    <CuadroColapsable
      etiqueta={'País'}
      valorDestacado={geografia.pais?.nombre}
      expandidoPorDefecto={geografia.expandidoPaises}
      onExpandChange={onExpandPaisesChange}
    >
      <ListaItemsGeo
        tipo={TipoItemGeo.PAIS}
        geografia={geografia}
        itemActual={geografia.pais}
        recargar={geografia.actualizarPaises}
        onItemElegido={onItemElegido}
        onInsertarItem={onInsertarItem}
      />
    </CuadroColapsable>
  );

  // Componente para Provincias
  const ListaProvinciasDesktop = (
    <ListaItemsGeo
      tipo={TipoItemGeo.PROVINCIA}
      geografia={geografia}
      itemActual={geografia.provincia}
      recargar={geografia.actualizarProvincias}
      onItemElegido={onItemElegido}
      onInsertarItem={onInsertarItem}
    />
  );

  const ListaProvinciasColapsable = (
    <CuadroColapsable
      etiqueta={'Provincia'}
      valorDestacado={geografia.provincia?.nombre}
      expandidoPorDefecto={geografia.expandidoProvincias}
      onExpandChange={onExpandProvinciasChange}
    >
      <ListaItemsGeo
        tipo={TipoItemGeo.PROVINCIA}
        geografia={geografia}
        itemActual={geografia.provincia}
        recargar={geografia.actualizarProvincias}
        onItemElegido={onItemElegido}
        onInsertarItem={onInsertarItem}
      />
    </CuadroColapsable>
  );

  // Componente para Localidades
  const ListaLocalidadesDesktop = (
    <ListaItemsGeo
      tipo={TipoItemGeo.LOCALIDAD}
      geografia={geografia}
      itemActual={geografia.localidad}
      recargar={geografia.actualizarLocalidades}
      onItemElegido={onItemElegido}
      onInsertarItem={onInsertarItem}
    />
  );

  const ListaLocalidadesColapsable = (
    <CuadroColapsable
      etiqueta={'Localidad'}
      valorDestacado={geografia.localidad?.nombre}
      expandidoPorDefecto={geografia.expandidoLocalidades}
      onExpandChange={onExpandLocalidadesChange}
    >
      <ListaItemsGeo
        tipo={TipoItemGeo.LOCALIDAD}
        geografia={geografia}
        itemActual={geografia.localidad}
        recargar={geografia.actualizarLocalidades}
        onItemElegido={onItemElegido}
        onInsertarItem={onInsertarItem}
      />
    </CuadroColapsable>
  );

  // Solo renderizar la vista apropiada según breakpoint (no ambas)
  // Esto evita conflicto de testIds en tests
  if (UI.useUI().esDesktop) {
    return (
      <div className={styles.desktopView}>
        <div className={`${styles.contenedor}`}>
          <div className={styles.slotListaDesktop}>{ListaPaisesDesktop}</div>
          <div className={styles.slotListaDesktop}>{ListaProvinciasDesktop}</div>
          <div className={styles.slotListaDesktop}>{ListaLocalidadesDesktop}</div>
          <div className={`${styles.columnaCuadros}`}>
            {cuadroDatos}
            {cuadroTotales}
          </div>
        </div>
      </div>
    );
  }

  // Tablet/Mobile: listas colapsables
  return (
    <div className={styles.mobileView}>
      {ListaPaisesColapsable}
      {ListaProvinciasColapsable}
      {ListaLocalidadesColapsable}
      <div className={`${styles.columnaCuadros}`}>
        {cuadroDatos}
        {cuadroTotales}
      </div>
    </div>
  );
};

export default AdminGeografia;
